// src/shared/services/netlifyFetch.ts
//
// Zentrale Aufruffunktion des Frontends für Netlify-Funktionen
// (XTAX GmbH & Co. KG, Phase 0, Punkt 1).
//
// Bisher rief jeder Dienst die Netlify-Funktionen mit einem nackten fetch auf,
// ohne Ausweis. Mit der Aufruferprüfung auf der Netlify-Seite (staffAccess.js,
// requireCaller) verlangt jede Funktion künftig das Sitzungs-Token der
// angemeldeten Person im Authorization-Header. Damit das an genau einer Stelle
// passiert, laufen alle Aufrufe über diese Funktion.
//
// Der Ausweis ist das Supabase-Sitzungs-Token. Es trägt das Merkmal
// rolle=staff, an dem die Netlify-Seite einen Mitarbeiter erkennt; dasselbe
// Merkmal weist später Portalkunden als rolle=portal aus. Ein eigener
// Authorization-Header des Aufrufers bleibt unangetastet.
//
// Ohne Sitzung wird der Aufruf ohne Ausweis abgesetzt. Die Netlify-Seite
// antwortet dann mit 401, und der aufrufende Dienst zeigt seinen üblichen
// Fehler; die Anmeldung selbst läuft über auth.service und wird hier nicht
// nachgeholt.

import { supabase } from './supabase';

export async function netlifyFetch(input: string, init: RequestInit = {}): Promise<Response> {
  const headers = new Headers(init.headers ?? undefined);

  if (!headers.has('Authorization')) {
    try {
      const { data } = await supabase.auth.getSession();
      const token = data.session?.access_token;
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
    } catch (error) {
      console.warn('netlifyFetch: Sitzung nicht lesbar, Aufruf ohne Ausweis', error);
    }
  }

  return fetch(input, { ...init, headers });
}
